import Apod from "../components/Apod";

const ApodPage = () => {
  return (
    <div className="container mx-auto">
      <Apod />
    </div>
  );
};

export default ApodPage;
